import { useState } from 'react'

/**
 * A true/false preference kept in this browser's localStorage. Falls back to `fallback` when nothing is saved
 * or storage is blocked (private window, cleared site data), and never throws.
 */
export function usePersistentFlag(key: string, fallback: boolean) {
  const [value, setValue] = useState(() => {
    try {
      const v = localStorage.getItem(key)
      return v === null ? fallback : v === '1'
    } catch {
      return fallback
    }
  })
  const set = (v: boolean) => {
    setValue(v)
    try {
      localStorage.setItem(key, v ? '1' : '0')
    } catch {
      /* not saved: fine, it just won't be remembered */
    }
  }
  return [value, set] as const
}
